
const AppAuth = () => {
  return (
    <div>
      <p>msal sso authentication</p>
    </div>
  );
};

export default AppAuth; 
